import { useState, createContext } from "react";
import log from "loglevel";

const MenuContext = createContext({
  menuState: {
    menuListVisible: false,
    userMenuVisible: false,
  },
  modalActions: {
    setMenuListVisible: () => {},
    setUserMenuVisible: () => {},
  },
});

const MenuProvider = ({ children }) => {
  log.debug('CONTEXT_MENU_PROVIDER');

  const [menuListVisible, setMenuListVisible] = useState(false);
  const [userMenuVisible, setUserMenuVisible] = useState(false);

  const value = {
    menuState: {
      menuListVisible,
      userMenuVisible,
    },
    menuActions: {
      setMenuListVisible,
      setUserMenuVisible,
    },
  };

  return (
    <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
  );
};

export { MenuProvider };

export default MenuContext;
